import styles from './ua.module.scss'

export default function Tiles(props) {
  
  return <div className={styles.tiles}>
    <div className={styles.tilesInner + ' ' + (props.column ? styles.tilesColumn : '') + (props.size ? ' ' + styles[props.size + "Tiles"] : '') + (props.padded ? ' ' + styles.tilesPadded : '')}>{ props.children }</div>
  </div>
  
}